import React  from 'react';
import { Row, Col, Button, Label } from 'reactstrap';
import { Field, FormGroup } from '@availity/form';
import PropTypes from 'prop-types';
import qualityStore from '../stores/QualityStore';

const setPractitionerFirst = (event, index) => {
  const {value} = event.target;
  qualityStore.setPractitionerFirst(index, value);
}

const setPractitionerLast = (event, index) => {
  const {value} = event.target;
  qualityStore.setPractitionerLast(index, value);
}

const setPractitionerNPI = (event, index) => {
  const {value} = event.target;
  qualityStore.setPractitionerNPI(index, value);
}

const PractitionerComponent = props => {
  const {index, firstName, lastName, npi} = props;

  return (
    <>
      <Row className="mt-35">
        <Col xs="10" sm="11" md="11">
          <h5>
            {`Provider ${index + 2}`}
          </h5>
        </Col>
        <Col xs="2" sm="1" md="1">
          <Button 
            close
            className={`practitioner_${index + 2}`}
            onClick={() => {
              props.handleRemovePractitioner(index);
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="6" md="6">
          <FormGroup for={`practitioner_first_${index}`}>
            <Label for={`practitioner_first_${index}`}>
              First Name
            </Label>
            <Field
              type="text"
              id={`practitioner_first_${index}`}
              name={`practitioner_first_${index}`}
              onChange={(e) => setPractitionerFirst(e, index)}
              value={firstName}
              maxLength={50}
            />
          </FormGroup>
        </Col>
        <Col xs="12" sm="6" md="6">
          <FormGroup for={`practitioner_last_${index}`}>
            <Label for={`practitioner_last_${index}`}>
              Last Name
            </Label>
            <Field
              type="text"
              id={`practitioner_last_${index}`}
              name={`practitioner_last_${index}`}
              onChange={(e) => setPractitionerLast(e, index)}
              value={lastName}
              maxLength={50}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="6" md="6">
          <FormGroup for={`practitionerNPI_${index}`}>
            <Label for={`practitionerNPI_${index}`}>
              NPI
            </Label>
            <Field
              type="text"
              id={`practitionerNPI_${index}`}
              name={`practitionerNPI_${index}`}
              onChange={(e) => setPractitionerNPI(e, index)}
              value={npi}
              maxLength={10}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}

PractitionerComponent.propTypes = {
  index: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  npi: PropTypes.string,
  handleRemovePractitioner: PropTypes.func
}

export default PractitionerComponent;